import dateformat from 'dateformat';

import setCookie from '@stencil/flights-utils/src/set-cookie';
import getCookie from '@stencil/flights-utils/src/get-cookie';

import { EMPTY_STRING, ADULT, CHILD, INFANT } from '@stencil/flights-constants/src/text';

import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import { getFromUrlObject, getFromUrlObjectForGroundUp } from '../../Home/utils/searchDataUtils';
import addDays from '@stencil/date-utils/src/addDays';

import { setDirectlyLandedOnSrp } from '../../SRP/redux/actions';
import { updateSearchData } from '../../Home/redux/actions';
import { updateSearchStringForGroundUp } from '../../SRP/redux-lite/actions';
import { v4 as uuidv4 } from 'uuid';

export function isObjectEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

// format tt (time for delayed ticketing)
export function getDTTime(dt) {
  const dtArr = dt.split('/');
  const adt = dtArr[0];
  const mdt = dtArr[1];
  let val = adt;
  if (mdt || adt === '0:0:0') {
    val = mdt;
  }
  const arr = val.split(':');
  return `${arr[0] !== '0' ? arr[0] + ' days' : ''} ${arr[1] !== '0' ? arr[1] + ' hours' : ''} ${
    arr[2] !== '0' ? arr[2] + ' minutes' : ''
  }`;
}

export const getDateFromYYYYMMDDString = dateInYYYYMMDD => {
  const newDate = new Date(
    dateInYYYYMMDD.substring(0, 4),
    dateInYYYYMMDD.substring(4, 6) - 1,
    dateInYYYYMMDD.substring(6, 8)
  );
  return newDate;
};

export function dateDiff(date1, date2) {
  const firstDate = new Date(date1);
  firstDate.setHours(0, 0, 0, 0);
  const secondDate = new Date(date2);
  secondDate.setHours(0, 0, 0, 0);
  const diffDays = Math.floor((secondDate.getTime() - firstDate.getTime()) / (24 * 60 * 60 * 1000));
  return diffDays;
}

export function isPastNumberOfDays(date: Date, noOfDays: number) {
  const today = new Date();
  const dateToCompareWith =
    noOfDays > 0 ? new Date(today.setDate(today.getDate() + noOfDays)) : today;
  return date.setHours(0, 0, 0, 0) - dateToCompareWith.setHours(0, 0, 0, 0) < 0;
}

export const getDateInYYYYMMDD = (date: Date) => {
  return dateformat(date, 'yyyymmdd');
};

export const setSrpFromRepriceAddons = (params, dispatch) => {
  const urlObj = getFromUrlObject(params);
  dispatch(setDirectlyLandedOnSrp({ params: { 0: params }, searchString: '' }));
  dispatch(updateSearchData(urlObj));
};

export const setSrpMebLiteFromRepriceAddons = (searchString, dispatch) => {
  const urlObj = getFromUrlObjectForGroundUp(searchString);
  dispatch(updateSearchStringForGroundUp(searchString));
  dispatch(updateSearchData(urlObj));
};

export const getUniqueId = (key = 'gi_flt_identity') => {
  const val = getCookie(key);
  if (!val) {
    const cookieVal = new Date().getTime();
    setCookie(key, cookieVal, '', '/', window.location.host.replace('www.', ''), '');
    return cookieVal;
  }
  return val;
};

export const getPDTDetails = (fareIdentifier, fareOptionsInfo) => {
  if (fareIdentifier && fareOptionsInfo) {
    const fareOptions = Object.values(fareOptionsInfo);
    const fare = [].concat.apply([], fareOptions);
    const fareDetails = fare.find(o => o['identifier'] == fareIdentifier);
    return fareDetails;
  }
};

export const getSrpQueryParams = (flightSearchData, query = false) => {
  const {
    source,
    destination,
    departure,
    arrival,
    passengers,
    flightClass,
    journeyType,
    travelType
  } = flightSearchData;
  const EMPTY_STRING = '';
  const DOMESTIC = 'domestic';
  const DOMESTIC_TYPE = query ? '-100--' : '-D';
  const INTERNATIONAL_TYPE = query ? '-0' : '-I';
  return `${source.iata}-${destination.iata}-${departure.yyyymmdd}-${
    journeyType === 'rt' ? arrival?.yyyymmdd : EMPTY_STRING
  }-${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}${
    travelType === DOMESTIC ? DOMESTIC_TYPE : INTERNATIONAL_TYPE
  }`;
};

export const getUrlParam = (flightSearchData, isQuery = false) => {
  const { source, destination, departure, arrival } = flightSearchData;
  if (source.iata === destination.iata) {
    return null;
  }
  if (arrival && departure && arrival.dateObj < departure.dateObj) {
    return null;
  }
  return `air-${getSrpQueryParams(flightSearchData, isQuery)}`;
};

export const getSrpQueryParamsForCityCountry = (
  flightSearchData,
  selectedDestination,
  defaultCityCountryData,
  query = false
) => {
  if (!selectedDestination || !selectedDestination.toCity) {
    return null;
  }

  const { departure } = flightSearchData;
  const { tripDuration, journeyType } = defaultCityCountryData;
  const destination = { iata: selectedDestination?.toCity };
  const arrival =
    journeyType === 'rt' ? getDateObject(addDays(new Date(departure.dateObj), tripDuration)) : null;

  return getUrlParam({ ...defaultCityCountryData, destination, departure, arrival }, query);
};

export const getCookieString = cookieObj => {
  let cookieStr = '';
  if (
    typeof cookieObj === 'object' &&
    !Array.isArray(cookieObj) &&
    cookieObj !== null &&
    Object.keys(cookieObj).length
  ) {
    const arr = Object.keys(cookieObj);
    cookieStr += `${arr[0]}=${cookieObj[arr[0]]};`;
    for (let i = 1; i < arr.length; i++) {
      cookieStr += ` ${arr[i]}=${cookieObj[arr[i]]};`;
    }
  }
  return cookieStr;
};

export const getObjectWithTitle = (dataArray, titleName) => {
  return dataArray?.find(data => data['Title'] === titleName);
};

const fallbackCopyTextToClipboard = text => {
  try {
    var textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
  } catch (ex) {
    throw ex;
  } finally {
    document.body.removeChild(textArea);
  }
};

export const copyTextToClipboard = async text => {
  try {
    if (!navigator.clipboard) {
      return fallbackCopyTextToClipboard(text);
    }
    return navigator.clipboard.writeText(text);
  } catch (ex) {
    throw ex;
  }
};

export const getPassengersText = passengers => {
  let txt = `${passengers.adult} ${ADULT}${passengers.adult > 1 ? 's' : EMPTY_STRING}`;
  if (passengers.child) {
    txt += ` ${passengers.child} ${CHILD}${passengers.child > 1 ? 'ren' : EMPTY_STRING}`;
  }
  if (passengers.infant) {
    txt += ` ${passengers.infant} ${INFANT}${passengers.infant > 1 ? 's' : EMPTY_STRING}`;
  }
  return txt;
};

const generateUniqueId = () => {
  return 'xxxxx-xxxxx-xxxx-xxxxx'.replace(/[x]/g, c => {
    const r = Math.floor(Math.random() * 16);
    return r.toString(16);
  });
};

export const getDeviceId = (key = 'gi_flt_session', expiryTime = 525600) => {
  //set default expiry time to an year
  let uid = getCookie(key);
  if (!uid && key !== 'gi_flt_session') {
    const now = new Date();
    const minutes = expiryTime;
    now.setTime(now.getTime() + minutes * 60 * 1000);
    const expiry = now.toUTCString();
    uid = uuidv4();
    setCookie(key, uid, expiry, '/', window.location.host.replace('www.', ''), '');
  }
  return uid;
};

// export const deleteSearchParamsFromGivenSearchQuery = (searchQuery, paramToBeDeletedList) => {
//   if (!searchQuery || !searchQuery.length) {
//     return '';
//   }

//   let searchString = '';
//   const searchQueryArray = searchQuery?.replace('?', '')?.split('&');
//   for (let i = 0; i < searchQueryArray.length; i++) {
//     let deleteParam = false;
//     for (let j = 0; j < paramToBeDeletedList.length; j++) {
//       if (searchQueryArray[i]?.split('=')[0] === paramToBeDeletedList[j]) {
//         deleteParam = true;
//         break;
//       }
//     }
//     if (!deleteParam) {
//       searchString = `${i > 0 ? '&' : '?'}${searchString}`;
//     }
//   }

//   return searchString;
// };
